module.exports = __webpack_public_path__ + "img/7_no.0d93a385.svg";